import { Device, waitFor } from '@goodboydigital/astro';
import { Container } from 'pixi.js';

import { BillboardCar } from './BillboardCar';
import { BillboardIcon } from './BillboardIcon';
import { BillboardKeys } from './BillboardKeys';
import { BillboardRotator } from './BillboardRotator';

export class BillboardTutorialRotateCW extends Container
{
    private mobile: boolean;
    private car: BillboardCar;
    private icon: BillboardIcon;
    private animating = false;

    // Desktop controls
    private keys?: BillboardKeys;

    // Mobile controls
    private rotator?: BillboardRotator;

    constructor()
    {
        super();

        this.mobile = Device.mobile;

        this.icon = new BillboardIcon('icon-replay', -1);
        this.addChild(this.icon);
        this.icon.x = -100;
        this.icon.y = -80;

        this.car = new BillboardCar();
        this.addChild(this.car);
        this.car.x = -110;
        this.car.y = -10;

        this.mobile ? this.setupMobile() : this.setupDesktop();
    }

    private setupDesktop(): void
    {
        this.keys = new BillboardKeys();
        this.addChild(this.keys);
        this.keys.visible = !this.mobile;
        this.keys.x = 120;
        this.keys.y = -33;
        this.keys.scale.set(0.7);
        this.keys.right.highlight();
    }

    private setupMobile(): void
    {
        this.rotator = new BillboardRotator('cw');
        this.rotator.x = 100;
        this.rotator.y = -55;
        this.rotator.scale.set(0.85);
        this.addChild(this.rotator);
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.animate();
    }

    private async animate(): Promise<void>
    {
        if (this.animating) return;
        this.animating = true;

        await waitFor(200);

        // Go away
        this.keys?.right.press();
        this.rotator?.press();
        this.icon.spin(1, 1);
        await this.car.lean(1, 1);

        // Come back
        this.keys?.right.release();
        this.rotator?.release();
        await this.car.leanBack();

        await waitFor(200);

        this.animating = false;
    }
}
